<div class="lang-selector-wrapper">
  <!-- Trigger Button -->
  <button
    type="button"
    class="lang-trigger-btn"
    [class.active]="isOpen"
    (click)="toggleDropdown()"
    aria-label="Select Language"
    [attr.aria-expanded]="isOpen">
    <span class="lang-flag">{{ currentLang.flag || '🌐' }}</span>
    <span class="lang-text">{{ currentLang.name || currentLang.english_name }}</span>
    <span class="lang-code-badge">{{ currentLang.language.toUpperCase() }}</span>
    <svg class="lang-caret" [class.open]="isOpen" width="10" height="6" viewBox="0 0 10 6" fill="none">
      <path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </button>

  <!-- Light Theme Popup Dropdown -->
  <div class="lang-dropdown" *ngIf="isOpen">
    <div class="lang-dropdown-header">
      <div class="lang-dropdown-title">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="2" y1="12" x2="22" y2="12"></line>
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
        </svg>
        <span>Select Language</span>
      </div>
      <button type="button" class="lang-close-btn" (click)="closeDropdown()" aria-label="Close">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Popular Languages List -->
    <div class="lang-list-container">
      <button
        type="button"
        class="lang-item"
        *ngFor="let lang of popularLanguages"
        [class.active]="currentLang.code === lang.code"
        (click)="selectLanguage(lang)">
        <div class="lang-item-info">
          <span class="lang-item-flag">{{ lang.flag || '🌐' }}</span>
          <div class="lang-item-labels">
            <span class="lang-native-name">{{ lang.name }}</span>
            <span class="lang-english-name">{{ lang.english_name }} ({{ lang.code }})</span>
          </div>
        </div>

        <span class="lang-check-icon" *ngIf="currentLang.code === lang.code">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </span>
      </button>
    </div>
  </div>
</div>
